export default __webpack_public_path__ + "static/media/Img0017.22cec64a.jpg";